import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { apisiseci } from "../../../../../../api";
import { AttendanceLocalDepartment } from "../../../../../../../@types/attendance-local-department";
import { AttendanceLocalDepartmentQueueServiceTimeException } from "../../../../../../../@types/attendance-local-department-queue-service-time-exception";

export type AttendanceLocalDepartmentQueueServiceTimeExceptionCreateData = Pick<
    AttendanceLocalDepartmentQueueServiceTimeException,
    | "fila"
    | "data"
    | "tempo_presencial"
    | "tempo_online"
    | "horario_especial_agendamento"
    | "hora_inicio_agendamento"
    | "hora_fim_agendamento"
    | "intervalo_hora_inicio_agendamento"
    | "intervalo_hora_fim_agendamento"
    | "horario_especial_diario"
    | "hora_inicio_diario"
    | "hora_fim_diario"
    | "intervalo_hora_inicio_diario"
    | "intervalo_hora_fim_diario"
> & {
    setor: AttendanceLocalDepartment["id"];
    servico: AttendanceLocalDepartmentQueueServiceTimeException["servico"]["id"];
}

export function useAttendanceLocalDepartmentQueueServiceTimeExceptionDelete() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    return useMutation<
        void,
        AxiosError<{ detail: string }>,
        number // id da exceção a ser removida
    >({
        mutationKey: ["attendance-local", "department", "queue", "service-time-exception", "delete"],
        mutationFn: async (id: number) => {
            await apisiseci.delete(`/cms/excecao_horario_agendamento/${id}/`, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['attendance-local', 'department', 'queue', 'service-time-exception', 'list']
            });
            toast.success("Exceção de tempo de serviço removida com sucesso!");
        },
        onError: (error) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });
}
